<template>
  <!--<el-scrollbar>-->
  <div id="app">
    <transition name="router-transform"
                mode="out-in">
      <router-view />
    </transition>
  </div>
  <!--</el-scrollbar>-->
</template>

<script>
export default {
  name: 'app',
}
</script>

<style>
  /* 纵向滚动条出现时，表头样式对齐 */
  body .el-table--scrollable-y .el-table__header {
    table-layout: auto;
  }
  /* 统一滚动条大小 */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  /* 横向纵向滚动条相交的小方块样式 */
  .el-table__body-wrapper::-webkit-scrollbar-corner {
    background: rgba(42, 42, 42, 1);
    height: 8px;
  }
  /* 禁止路由切换产生滑动条闪烁 */
  body {
    overflow-x: hidden;
    overflow-y: auto;
  }
</style>


// WEBPACK FOOTER //
// src/App.vue